import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { matchPath } from 'react-router-dom'

import { apiResourceEndpoint, routes } from '../../constants/routes'
import { saveNavClick } from '../../reducers/nav'
import { withRouterProps } from '../utils/with-router-props'
import { fetchApiData } from '../../actions/api'

const mapStateToProps = (state) => {
    return {
        navState: state.nav
    }
}

const Preloader = ({ dispatch, location, navState }) => {
    const completeSiteInitialization = () => {
        const activeRoute = Object.values(routes).find(route => matchPath({ path: route.path }, location.pathname))
        if (activeRoute) {
            dispatch(saveNavClick(
                {
                    url: location.pathname,
                    preLoadingComponent: activeRoute.component,
                    animatingInComponent: null,
                    animatingOutComponent: 'Preloader'
                }
            ))
        }
    }

    useEffect(() => {
        dispatch(fetchApiData(apiResourceEndpoint('init', 'LIST')))
            .then(() => {
                completeSiteInitialization()
            })
    }, [dispatch])

    if (navState.activeComponent !== 'Preloader') {
        return null
    }

    return (
        <div className="preloader">
            <h1 style={{ marginBottom: '1rem' }}>Way Outta<br />No Way</h1>
            <p>Loading...</p>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(Preloader))
